export const PROXY_URL = "https://staff.lasgidirestaurant.com/php/proxy.php";

export const apiRequest = async ({ script, data = {}, token = null }) => {
  try {
    let headers = {};
    let body;
    const isFormData = data instanceof FormData;

    if (isFormData) {
      const form = new FormData();

      for (const [key, value] of data.entries()) {
        form.append(key, value);
      }

      form.append("script", script);

      if (token) {
        form.append("api_token", token);
      }

      body = form;
    } else {
      headers["Content-Type"] = "application/json";

      body = JSON.stringify({
        script,
        api_token: token,
        data,
      });
    }

    const res = await fetch(PROXY_URL, {
      method: "POST",
      headers,
      body,
    });

    const text = await res.text();

    let result;
    try {
      result = JSON.parse(text);
    } catch (err) {
      console.error("Invalid JSON response:", text);
      throw new Error("Invalid JSON response from server");
    }

    return result;
  } catch (error) {
    console.error("API request failed:", error);
    return {
      success: false,
      error: error.message || "Request failed",
    };
  }
};